function ResetPassword() {
  return <>Reset Password page</>;
}
export default ResetPassword;
